import { useState, useEffect } from "react";
import HealthOverviewContext from "./HealthOverviewContext";
import { SpaceIOService } from "auth-utils";

import axios from "axios";

const HealthOverviewProvider = ({ children }) => {
  const [accountsInfo, setAccountsInfo] = useState(null);
  const [quickInfoData, setQuickInfoData] = useState({});
  // const [locationsInfo, setLocationsInfo] = useState(null)

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const authKey = localStorage.getItem("spaceio-key");

  const fetchHealthDataFloorWise = async (arrayOfFloorAssetId: string[]) => {
    if (arrayOfFloorAssetId.length > 0) {
      let data = JSON.stringify(arrayOfFloorAssetId);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.SPOT_BASE_URL}/assets/data/119/current`,
        headers: {
          authorization: `bearer ${authKey}`,
        },
        data: data,
      };
      try {
        const response = await axios.request(config);
        // console.log(response.data);
        return response.data;
      } catch (error) {
        console.error("An error occurred in the axios request:", error);
      }
    } else {
      return [];
    }
  };

  const fetchTOtalDeviceDataFloorWise = async (
    arrayOfFloorAssetId: string[]
  ) => {
    if (arrayOfFloorAssetId.length > 0) {
      let data = JSON.stringify(arrayOfFloorAssetId);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.SPOT_BASE_URL}/assets/data/117/current`, //117 total number of device
        headers: {
          authorization: `bearer ${authKey}`,
        },
        data: data,
      };
      try {
        const response = await axios.request(config);
        // console.log(response.data);
        return response.data;
      } catch (error) {
        console.error("An error occurred in the axios request:", error);
      }
    } else {
      return [];
    }
  };

  const fetchliveAccount = async () => {
    const init = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.PROD_WS_BASE_URL}/api/accounts/liveAccountIds`,
      headers: {
        accept: "application/json, text/javascript, */*; q=0.01",
      },
    };
    try {
      const response = await SpaceIOService.request(
        `${process.env.PROD_WS_BASE_URL}/api/accounts/liveAccountIds`,
        init
      );
      const responseData = await response.json();
      return responseData;
    } catch (e) {
      throw e;
    }
  };

  const fetchListofAccountWithLocation = async () => {
    const init = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.PROD_WS_BASE_URL}/api/admin/accounts/locations/confupdates`,
      headers: {
        accept: "application/json, text/javascript, */*; q=0.01",
      },
    };
    try {
      const response = await SpaceIOService.request(
        `${process.env.PROD_WS_BASE_URL}/api/admin/accounts/locations/confupdates`,
        init
      );
      const responseData = await response.json();

      // console.log(responseData);

      const aarayOfAssetId = [];
      responseData.forEach((item) => {
        const arrayOfLocation = item.locations;
        const arrayofAssetId = arrayOfLocation.map(
          (item: { assetId: string }) => item.assetId
        );
        // console.log(arrayofAssetId);
        aarayOfAssetId.push(...arrayofAssetId);
      });

      // console.log(aarayOfAssetId);
      const arrayOfHealtyDeviceAccount = await fetchHealthDataFloorWise(
        aarayOfAssetId
      );
      const arrayOfTotalDeviceAccount = await fetchTOtalDeviceDataFloorWise(
        aarayOfAssetId
      );
      // console.log(arrayOfHealtyDeviceAccount);
      // console.log(arrayOfTotalDeviceAccount);

      const liveaccountData = await fetchliveAccount();
      const status = await mediaServerStatus();
      // console.log("My Data one", status);
      

      responseData.forEach((data) => {
        const isPresent = liveaccountData.includes(data.id);
        if (isPresent) {
          data.showInMenu = true;
        } else {
          data.showInMenu = false;
        }
      });

      let productLevelDeviceHealth = {
        ONE: { healthy: 0, total: 0, accountCount: 0 },
        TIM: { healthy: 0, total: 0, accountCount: 0 },
        "TIM+": { healthy: 0, total: 0, accountCount: 0 },
        "BAT-TIM": { healthy: 0, total: 0, accountCount: 0 },
        "BAT-TIM+": { healthy: 0, total: 0, accountCount: 0 },
        PAL: { healthy: 0, total: 0, accountCount: 0 },
        PAM: { healthy: 0, total: 0, accountCount: 0 },
        FLO: { healthy: 0, total: 0, accountCount: 0 },
        MS: { healthy: 0, total: 0, accountCount: 0 },
        SIGNAGE: { healthy: 0, total: 0, accountCount: 0 },
      };

      await Promise.all(
        responseData.map(
          async (item: {
            locations: [];
            id: number;
            name: string;
            accountLevelDeviceHealth?: {
              ONE: number;
              TIM: number;
              "TIM+": number;
              "BAT-TIM": number;
              "BAT-TIM+": number;
              PAL: number;
              PAM: number;
              FLO: number;
              MS: number;
            };
            status?: [];
          }) => {
            const arrayOfLocation = item.locations;
            console.log("Hello World", item);

            const arrayofAssetId = arrayOfLocation.map(
              (item: { assetId: string }) => item.assetId
            );
            // console.log("item",arrayofAssetId)

            const arrayOfHealtyDeviceAcount = arrayOfHealtyDeviceAccount.filter(
              (item) => arrayofAssetId.includes(item.id)
            );

            const arrayOfTotalDeviceAcount = arrayOfTotalDeviceAccount.filter(
              (item) => arrayofAssetId.includes(item.id)
            );

            // console.log(arrayOfHealtyDeviceAcount);
            // console.log(arrayOfTotalDeviceAcount);

            // const arrayOfHealtyDeviceAcount = await fetchHealthDataFloorWise(arrayofAssetId);
            // console.log(arrayOfHealtyDeviceAcount);
            // const arrayOfTotalDeviceAcount = await fetchTOtalDeviceDataFloorWise(arrayofAssetId);

            let accountLevelDeviceHealth = {
              Overall: 0,
              ONE: 0,
              TIM: 0,
              "TIM+": 0,
              "BAT-TIM": 0,
              "BAT-TIM+": 0,
              PAL: 0,
              PAM: 0,
              FLO: 0,
              MS: 0,
            };

            let accountLevelTotalDevices = {
              Overall: 0,
              ONE: 0,
              TIM: 0,
              "TIM+": 0,
              "BAT-TIM": 0,
              "BAT-TIM+": 0,
              PAL: 0,
              PAM: 0,
              FLO: 0,
              MS: 0,
            };

            let accountLevelDeviceHealthPercentage = {
              Overall: 0,
              ONE: 0,
              TIM: 0,
              "TIM+": 0,
              "BAT-TIM": 0,
              "BAT-TIM+": 0,
              PAL: 0,
              PAM: 0,
              FLO: 0,
              MS: 0,
            };

            // Total number of device for each floor
            arrayOfHealtyDeviceAcount.forEach((floorWiseHealthDevice: any) => {
              Object.keys(floorWiseHealthDevice).forEach((key) => {
                if (
                  accountLevelTotalDevices.hasOwnProperty(key) &&
                  floorWiseHealthDevice.hasOwnProperty(key)
                ) {
                  accountLevelDeviceHealth[key] += floorWiseHealthDevice[key];
                }
              });
            });
            // console.log(accountLevelDeviceHealth);

            // Total number of device for each floor
            arrayOfTotalDeviceAcount.forEach((floorWiseTotalDevice: any) => {
              Object.keys(floorWiseTotalDevice).forEach((key) => {
                if (
                  accountLevelTotalDevices.hasOwnProperty(key) &&
                  floorWiseTotalDevice.hasOwnProperty(key) &&
                  floorWiseTotalDevice[key] !== 0
                ) {
                  accountLevelTotalDevices[key] += floorWiseTotalDevice[key];
                }
              });
            });
            // console.log(accountLevelTotalDevices);

            // Calculate percentage health for each device type
            Object.keys(accountLevelDeviceHealthPercentage).forEach((key) => {
              if (key !== "Overall" && accountLevelTotalDevices[key] > 0) {
                accountLevelDeviceHealthPercentage[key] = parseFloat(
                  (
                    (accountLevelDeviceHealth[key] /
                      accountLevelTotalDevices[key]) *
                    100
                  ).toFixed(2)
                );
              } else {
                accountLevelDeviceHealthPercentage[key] = null;
              }
            });

            // Calculate Overall percentage health excluding 'ONE'
            let OverallHealthyDevices = Object.entries(
              accountLevelDeviceHealth
            ).reduce((acc, [key, val]) => {
              // Exclude 'ONE' product from accumulation
              if (typeof val === "number") {
                return acc + val;
              }
              return acc;
            }, 0);

            let OverallTotalDevices = Object.entries(
              accountLevelTotalDevices
            ).reduce((acc, [key, val]) => {
              // Exclude 'ONE' product from accumulation
              if (typeof val === "number") {
                return acc + val;
              }
              return acc;
            }, 0);

            if (OverallTotalDevices > 0) {
              accountLevelDeviceHealthPercentage.Overall = parseFloat(
                ((OverallHealthyDevices / OverallTotalDevices) * 100).toFixed(2)
              );
            } else {
              accountLevelDeviceHealthPercentage.Overall = null;
            }

            // console.log(accountLevelDeviceHealthPercentage);

            // console.log('----------------------------------');

            // Accumulate health and total devices for each product
            Object.keys(productLevelDeviceHealth).forEach((key) => {
              if (accountLevelTotalDevices[key] > 0) {
                productLevelDeviceHealth[key].accountCount++;
              }
              productLevelDeviceHealth[key].healthy +=
                accountLevelDeviceHealth[key];
              productLevelDeviceHealth[key].total +=
                accountLevelTotalDevices[key];
            });
            item.accountLevelDeviceHealth = accountLevelDeviceHealthPercentage;
            const accountStatus = status?.responseData.filter(data=> data.accountId === item.id);
            item.accountLevelDeviceHealth.MS = (accountStatus?.filter(data => data.overallStatus === "danger").length / accountStatus.length) * 100; 
            
        
            // Populate your productLevelDeviceHealth object here based on the results of your API calls
          }
        )
      );
      productLevelDeviceHealth.SIGNAGE = status;

      return {
        productLevelDeviceHealth,
        responseData,
      };
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  const mediaServerStatus = async () => {
    try {
      const init = {
        method: "get",
        maxBodyLength: Infinity,
        url: `https://data.afreespace.com/admin/player/status`,
        headers: {
          accept: "application/json, text/javascript, */*; q=0.01",
        },
      };
      const response = await SpaceIOService.request(
        `https://data.afreespace.com/admin/player/status`,
        init
      );
      const responseDataObject = await response.json();
      const responseData = Object.values(responseDataObject) as {
        overallStatus: string;
        accountId: number
      }[];
      const successfulData = responseData.filter(
        (data) => data.overallStatus === "success"
      ).length;
      // console.log("Hello World Rohit", successfulData);

      return {
        healthy: successfulData,
        total: responseData.length,
        accountCount: 20,
        responseData: responseData
      };
    } catch (error) {}
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchListofAccountWithLocation();
        // console.log("Status Data",status);
        // console.log("Status Data Added", data.responseData);
        // data.productLevelDeviceHealth.SIGNAGE = status;
        setQuickInfoData(data.productLevelDeviceHealth);
        setAccountsInfo(data.responseData);
        setLoading(false);
      } catch (error) {
        // Handle errors here
        throw error;
        // console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={{ height: "100vh", width: "100%", textAlign: "center" }}>
        Loading...
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <HealthOverviewContext.Provider
      value={{
        accountsInfo: accountsInfo,
        quickInfoData: quickInfoData,
      }}
    >
      {children}
    </HealthOverviewContext.Provider>
  );
};

// Skip prop validation by setting propTypes to null
HealthOverviewProvider.propTypes = null;

export default HealthOverviewProvider;
